<template>
  <div>
    <x-grid :id="'roleTableList'"
            :rowId="rowId"
            :pager-config="pagerConfig"
            :url="url"
            :columns="columns"
            :cell-click="chooseRow"
            @returnForm="returnForm"
            ref="grid"
    >
    </x-grid>
  </div>
</template>

<script>
import XGrid from '@/components/grid/XGridPop'
import {GridPopMixin} from "@/utils/GridPopMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter"
import api from '@/services/api'

const fac = XGrid.factory;
console.info(fmt);//防止不使用便利 eslint报错


//列表接口
const url = api.comm.ROLE;
//主键
const rowId = 'roleId';
//方法表名 和表单中 方法判断名称一致
const tableName = 'roleTable';
//表格需要多选还是单选
const tableType = 'checkbox';

//列
const columns = [
  fac.makeColumnDefault(tableType),
  fac.makeColumn("roleName", "角色类型", 120),
  // fac.makeColumn("isSystem", "是否是系统角色", 140, 'center', true, fmt.formatYesNo),
  fac.makeColumn("remark", "备注", 120),
]

const pagerConfig = fac.makePagerConfig();

export default {
  mixins:[GridPopMixin],
  data() {
    return {
      tableType,
      tableName,
      columns,
      rowId,
      url,
      pagerConfig,
    }
  },
}
</script>

<style scoped>
</style>